import React, { useEffect, useRef } from "react";
import Footer from "../utilities/Footer";
import AppState from "../../util/AppState";
import { useTranslation } from "react-i18next";
import qrCodeIcon from "../../resources/scanqrcode.svg";
import connector from "../../resources/connector.svg";
import stepper1 from "../../resources/stepper-1.svg";
import stepper2 from "../../resources/stepper-2-disabled.svg";
import stepper3 from "../../resources/stepper-3-disabled.svg";
import { logFunctions as log } from "../../util/Logging";
import AlertDialog from "../utilities/AlertDialog";

function StagingScreen(props) {
  log.debug("+StagingScreen(TRACE)");

  const { t } = useTranslation("translation");
  const inputEl = useRef();
  let timer = null;

  useEffect(() => {
    log.debug("+StagingScreen_useEffect(TRACE)");
    inputEl.current.focus();
    log.debug("-StagingScreen_useEffect(TRACE)");
    return () => {
      clearTimeout(timer);
    };
  });

  const handleChange = (e) => {
    const qrInput = e.target.value;
    clearTimeout(timer);
    if (qrInput.indexOf("****") !== -1) {
      timer = setTimeout(() => {
        processScan(qrInput.substring(0, qrInput.indexOf("****")));
      }, 100);
    } else {
      timer = setTimeout(() => {
        log.error("StagingScreen_handleChange() => Error: invalid QR code");
        props.transitionToErrorStagingScreen();
      }, 100);
    }
  };

  const onButtonClick = () => {
    log.debug("+StagingScreen_onButtonClick(TRACE)");
    inputEl.current.focus();
    log.debug("-StagingScreen_onButtonClick(TRACE)");
  };

  const processScan = (qrInput) => {
    log.debug("+StagingScreen_processScan(TRACE)");
    let qrCodeConfig = "";
    let qrInputStr = "";

    try {
      qrInputStr = window.atob(qrInput);
      qrCodeConfig = JSON.parse(qrInputStr);
      log.info("StagingScreen_processScan() => QR Code is a valid JSON Object");
    } catch (e) {
      log.error("StagingScreen_processScan() => Error: %s", e.message);
      log.debug("-StagingScreen_processScan(TRACE)");
      props.transitionToErrorStagingScreen();
      return;
    }

    if (
      qrCodeConfig?.hasOwnProperty("Organization") &&
      qrCodeConfig?.hasOwnProperty("StyleSheetURL") &&
      qrCodeConfig?.hasOwnProperty("SupportedLocales") &&
      qrCodeConfig?.hasOwnProperty("SharedKey") &&
      qrCodeConfig?.hasOwnProperty("SecretKey")
    ) {
      log.info(
        "StagingScreen_processScan() => QR Code contains necessary staging information"
      );
      localStorage.setItem("orgID", qrCodeConfig?.Organization);
      localStorage.setItem("StyleSheetURL", qrCodeConfig?.StyleSheetURL);
      localStorage.setItem(
        "SupportedLocales",
        JSON.stringify(qrCodeConfig?.SupportedLocales)
      );
      localStorage.setItem("SharedKey", qrCodeConfig?.SharedKey);
      localStorage.setItem("SecretKey", window.btoa(qrCodeConfig?.SecretKey));
      localStorage.setItem("kioskLanguage", qrCodeConfig?.SupportedLocales[0]);
      log.info(
        "StagingScreen_processScan() => Setting kiosk language to: " +
          localStorage.getItem("kioskLanguage")
      );
      log.info(
        "StagingScreen_processScan() => Setting Staging information in localStorage"
      );
      log.debug("-StagingScreen_processScan(TRACE)");
      props.transitionToLoadingScreen();
    } else {
      log.error(
        "StagingScreen_processScan() => Error: QR Code does not contain valid staging information"
      );
      log.debug("-StagingScreen_processScan(TRACE)");
      props.transitionToErrorStagingScreen();
    }
  };

  log.debug("-StagingScreen(TRACE)");
  return (
    <div className="Screen" onClick={() => inputEl.current.focus()}>
      <div className="contentContainer">
        <div className="stepperContainer">
          <img
            id="stepper1"
            src={stepper1}
            alt="stepper1"
            className="stepperNumber"
          />
          <p id="step1TextLabel">{t("Scan QR Code")}</p>
          <img id="connector1" src={connector} alt="connector1" />
          <img
            id="stepper2"
            src={stepper2}
            alt="stepper2"
            className="stepperNumber"
          />
          <p id="step2TextLabel">{t("Set location and ID")}</p>
          <img id="connector2" src={connector} alt="connector2" />
          <img
            id="stepper3"
            src={stepper3}
            alt="stepper3"
            className="stepperNumber"
          />
          <p id="step3TextLabel">{t("Finish configuration")}</p>
        </div>
        <div className="qrCodeMessageBox">
          <p id="stagingTextLabel">
            {t(
              "Scan the QR code from your welcome email with the scanner below"
            )}
          </p>
          <img id="qrCodeIcon" src={qrCodeIcon} alt="qrCodeIcon" />
        </div>
        <div className="dontHaveQRCodeTextBox">
          <AlertDialog onButtonClick={onButtonClick} inputEl={inputEl} />
        </div>
      </div>
      <input
        style={{ position: "absolute", top: -100 }}
        ref={inputEl}
        id="qrInput"
        type="text"
        autoFocus
        onChange={(e) => handleChange(e)}
      />
      <div className="footerContainer" id="footer">
        <Footer
          transitionToSelectLanguageScreen={
            props.transitionToSelectLanguageScreen
          }
          state={AppState.STAGING_SCREEN}
        />
      </div>
    </div>
  );
}

export default StagingScreen;
